module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/map-marker-alt.svg?925845dd6e866c7ad1d701b9ef74eaeb";